/* OMINA — Pages post-achat.
   Deux rôles seulement, volontairement minimalistes :
   1. empêcher la double soumission du formulaire « Partage ton moment » et
      afficher un état d'envoi ;
   2. émettre les événements analytiques prévus, sans embarquer de traceur.

   Le formulaire fonctionne intégralement sans ce fichier : la validation est
   native et l'envoi passe par le formulaire de contact Shopify. */
(function () {
  if (window.ominaPostPurchase) return; // garde anti double initialisation

  /* Diffuse un événement nommé. Les outils de mesure installés par le marchand
     (Shopify Analytics, GTM, application) peuvent s'y abonner sans que le thème
     n'intègre lui-même le moindre script tiers. */
  function track(name, detail) {
    if (!name) return;
    document.dispatchEvent(
      new CustomEvent('omina:analytics', { detail: Object.assign({ event: name }, detail || {}) })
    );
    if (Array.isArray(window.dataLayer)) {
      window.dataLayer.push(Object.assign({ event: name }, detail || {}));
    }
  }

  function initAnalytics() {
    // Vue de page (hub post-achat)
    document.querySelectorAll('[data-omina-analytics]').forEach(function (el) {
      track(el.dataset.ominaAnalytics);
    });

    // Clics suivis
    document.querySelectorAll('[data-omina-analytics-click]').forEach(function (el) {
      el.addEventListener('click', function () {
        track(el.dataset.ominaAnalyticsClick);
      });
    });
  }

  function initForm() {
    var form = document.getElementById('OminaMomentForm');
    if (!form) return;

    var button = form.querySelector('[data-omina-form-submit]');
    var started = false;

    // Première interaction réelle avec un champ
    form.addEventListener(
      'input',
      function () {
        if (started) return;
        started = true;
        track('omina_moment_form_start');
      },
      { once: false }
    );

    form.addEventListener('submit', function (event) {
      // La validation HTML native reste maîtresse : on ne bloque rien nous-mêmes.
      if (!form.checkValidity()) return;

      if (form.dataset.submitting === 'true') {
        event.preventDefault(); // double clic ou double touche
        return;
      }
      form.dataset.submitting = 'true';

      track('omina_moment_form_submit');

      if (button) {
        button.classList.add('loading');
        button.setAttribute('aria-busy', 'true');
        var spinner = button.querySelector('.loading__spinner');
        if (spinner) spinner.classList.remove('hidden');
        // Le bouton reste actif jusqu'au déchargement : désactiver un input
        // avant l'envoi empêcherait Shopify de recevoir la soumission.
        setTimeout(function () {
          button.disabled = true;
        }, 0);
      }
    });

    // Retour d'une soumission réussie : on amène le focus sur la confirmation
    var success = document.querySelector('[data-omina-form-success]');
    if (success) {
      success.focus();
    }
  }

  function init() {
    initAnalytics();
    initForm();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  window.ominaPostPurchase = { track: track };
})();
